<div mat-dialog-content>
  <mat-stepper [linear]="true" #stepper orientation="vertical">
    <!-- Field step -->
    <mat-step [stepControl]="fieldFormGroup">
      <div style="margin-top: 1rem"></div>
      <ng-template matStepLabel>Select a field</ng-template>
      <ng-container *ngTemplateOutlet="constrainNameSelector"></ng-container>
      <div>
        <button mat-button matStepperNext>Next</button>
      </div>
    </mat-step>
    <!-- Style step -->
    <mat-step>
      <div style="margin-top: 1rem"></div>
      <ng-template matStepLabel>Aply style</ng-template>
      <ng-container *ngTemplateOutlet="constrainCreationStyle"></ng-container>
      <div>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button matStepperNext>Next</button>
      </div>
    </mat-step>
    <!-- Constrain step -->
    <mat-step>
      <div style="margin-top: 1rem"></div>
      <ng-template matStepLabel>Set constrain</ng-template>
      <ng-container [ngSwitch]="fieldConstrain.type">
        <!-- Numericos -->
        <ng-container
          *ngSwitchCase="1"
          [ngTemplateOutlet]="numberConstrainSelector"
        ></ng-container>
        <ng-container
          *ngSwitchCase="2"
          [ngTemplateOutlet]="numberConstrainSelector"
        ></ng-container>
        <ng-container
          *ngSwitchCase="4"
          [ngTemplateOutlet]="numberConstrainSelector"
        ></ng-container>

        <!-- Date -->
        <ng-container
          *ngSwitchCase="3"
          [ngTemplateOutlet]="dateConstrainSelector"
        ></ng-container>
        <!-- String -->
        <ng-container
          *ngSwitchCase="0"
          [ngTemplateOutlet]="stringConstrainSelector"
        ></ng-container>
        <ng-container
          *ngSwitchCase="5"
          [ngTemplateOutlet]="stringConstrainSelector"
        ></ng-container>
        <ng-container
          *ngSwitchCase="6"
          [ngTemplateOutlet]="stringConstrainSelector"
        ></ng-container>
      </ng-container>

      <div>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button matStepperNext>Next</button>
      </div>
    </mat-step>
    <!-- Final step -->
    <mat-step>
      <ng-template matStepLabel>Done</ng-template>
      <div style="width: 350px">
        <p
          class="mat-elevation-z4"
          [style]="{
            color: fieldConstrain.constrain.style['color'],
            'background-color':
              fieldConstrain.constrain.style['background-color'],
            padding: '1rem',
            'border-radius': '4px'
          }"
        >
          Every {{ valueType }} from column
          <strong>{{ fieldConstrain.constrainName }}</strong>
          {{ finalString }}
        </p>
      </div>
      <div>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button (click)="stepper.reset(); resetValues()">
          Reset
        </button>
        <button mat-button (click)="closeDialog()">Create</button>
      </div>
    </mat-step>
  </mat-stepper>
</div>

<ng-template #constrainNameSelector>
  <form [formGroup]="fieldFormGroup">
    <mat-form-field appearance="fill">
      <mat-label>Field</mat-label>
      <mat-select
        formControlName="field"
        required
        (ngModelChange)="onFieldSelectorChange($event)"
      >
        <mat-option>None</mat-option>
        <mat-option *ngFor="let column of data.columns" [value]="column">{{
          column.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</ng-template>

<ng-template #constrainCreationStyle>
  <mat-expansion-panel
    hideToggle
    [style]="{
      'background-color': fieldConstrain.constrain.style['background-color'],
      'margin-bottom': '1rem'
    }"
  >
    <mat-expansion-panel-header>
      <mat-panel-title
        [style]="{
          color: fieldConstrain.constrain.style['color'],
          'justify-content': 'center'
        }"
        >{{ fieldConstrain.constrainName }}</mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="flex-center">
      <app-lito-color-picker
        (result)="changeConstrainStyle($event, 'background-color')"
        content="Background"
      ></app-lito-color-picker>
      <app-lito-color-picker
        style="margin-left: 1rem"
        (result)="changeConstrainStyle($event, 'color')"
        content="Foreground"
      ></app-lito-color-picker>
    </div>
  </mat-expansion-panel>
</ng-template>

<ng-template #numberConstrainSelector>
  <mat-button-toggle-group
    class="number-constrain-selector"
    name="constrainSelect"
    aria-label="Constrain select"
    value="{{ fieldConstrain.constrain.type }}"
    (change)="changeConstrainState($event, 'number-type')"
  >
    <mat-button-toggle value="1" matTooltip="EQUALS">
      <mat-icon>drag_handle</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="2" matTooltip="MORE THAN">
      <mat-icon style="transform: rotate(90deg)">expand_less</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="3" matTooltip="LESS THAN">
      <mat-icon style="transform: rotate(90deg)">expand_more</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="4" matTooltip="BETWEEN">
      <mat-icon style="transform: rotate(90deg)">unfold_less</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="5" matTooltip="NOT BETWEEN">
      <mat-icon style="transform: rotate(90deg)">unfold_more</mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>
  <div
    *ngIf="
      fieldConstrain.constrain.type != numberConstrainType.BETWEEN &&
      fieldConstrain.constrain.type != numberConstrainType.NOTBETWEEN
    "
    style="display: flex; justify-content: space-between"
  >
    <mat-form-field style="width: 100%" appearance="fill">
      <mat-label
        (click)="$event.stopPropagation()"
        [ngSwitch]="fieldConstrain.constrain.type"
      >
        <span *ngSwitchCase="numberConstrainType.EQUALS">EQUALS</span>
        <span *ngSwitchCase="numberConstrainType.LESSTHAN">LESS THAN</span>
        <span *ngSwitchCase="numberConstrainType.MORETHAN">MORE THAN</span>
      </mat-label>
      <input
        type="number"
        step="0.1"
        (change)="
          $event.stopPropagation(); changeConstrainState($event, 'number-value')
        "
        (keyup)="
          $event.stopPropagation(); changeConstrainState($event, 'number-value')
        "
        matInput
        placeholder=""
        value="{{ fieldConstrain.constrain.values[0] }}"
      />
    </mat-form-field>
  </div>
  <!-- BETWEEN -->
  <div
    *ngIf="
      fieldConstrain.constrain.type == numberConstrainType.BETWEEN ||
      fieldConstrain.constrain.type == numberConstrainType.NOTBETWEEN
    "
    style="max-width: fit-content; display: flow-root"
  >
    <mat-form-field style="max-width: 45%; float: left" appearance="fill">
      <mat-label (click)="$event.stopPropagation()">{{
        fieldConstrain.constrain.type == numberConstrainType.BETWEEN
          ? "MORE THAN"
          : "LESS THAN"
      }}</mat-label>
      <input
        type="number"
        step="100"
        (change)="changeConstrainState($event, 'number-value1')"
        (keyup)="changeConstrainState($event, 'number-value1')"
        matInput
        placeholder=""
        [max]="fieldConstrain.constrain.values[1]"
        value="{{ fieldConstrain.constrain.values[0] }}"
      />
    </mat-form-field>
    <mat-form-field
      style="max-width: 45%; float: right"
      appearance="fill"
      (click)="$event.stopPropagation()"
      (keypress)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <mat-label
        (click)="$event.stopPropagation()"
        (keypress)="$event.stopPropagation()"
      >
        {{
          fieldConstrain.constrain.type == numberConstrainType.BETWEEN
            ? "LESS THAN"
            : "MORE THAN"
        }}
      </mat-label>
      <input
        type="number"
        step="100"
        (change)="changeConstrainState($event, 'number-value2')"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        (keypress)="$event.stopPropagation()"
        (keyup)="changeConstrainState($event, 'number-value2')"
        matInput
        placeholder=""
        [min]="fieldConstrain.constrain.values[0]"
        value="{{ fieldConstrain.constrain.values[1] }}"
      />
    </mat-form-field>
  </div>
</ng-template>

<ng-template #dateConstrainSelector>
  <mat-button-toggle-group
    class="number-constrain-selector"
    name="constrainSelect"
    aria-label="Constrain select"
    value="{{ fieldConstrain.constrain.type }}"
    (change)="changeConstrainState($event, 'date-type')"
  >
    <!-- <mat-button-toggle value="1" matTooltip="EQUALS">
      <mat-icon>drag_handle</mat-icon>
    </mat-button-toggle> -->
    <mat-button-toggle value="2" matTooltip="AFTER">
      <mat-icon style="transform: rotate(90deg)">expand_less</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="3" matTooltip="BEFORE">
      <mat-icon style="transform: rotate(90deg)">expand_more</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="4" matTooltip="BETWEEN">
      <mat-icon style="transform: rotate(90deg)">unfold_less</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="5" matTooltip="NOT BETWEEN">
      <mat-icon style="transform: rotate(90deg)">unfold_more</mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>
  <div style="display: flex; justify-content: space-between">
    <!-- EQUALS, LESSTHAN, MORETHAN -->
    <mat-form-field
      style="width: 100%"
      appearance="fill"
      *ngIf="
        fieldConstrain.constrain.type == numberConstrainType.EQUALS ||
        fieldConstrain.constrain.type == numberConstrainType.LESSTHAN ||
        fieldConstrain.constrain.type == numberConstrainType.MORETHAN
      "
    >
      <mat-label [ngSwitch]="fieldConstrain.constrain.type">
        <span *ngSwitchCase="numberConstrainType.EQUALS">EQUALS</span>
        <span *ngSwitchCase="numberConstrainType.LESSTHAN">Choose a date</span>
        <span *ngSwitchCase="numberConstrainType.MORETHAN">Choose a date</span>
        <span *ngSwitchCase="numberConstrainType.BETWEEN"
          >Choose a date range</span
        >
        <span *ngSwitchCase="numberConstrainType.NOTBETWEEN"
          >Choose a date range</span
        >
      </mat-label>

      <input
        matInput
        [matDatepicker]="picker"
        (dateChange)="changeConstrainState($event, 'date-value')"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <!-- BETWEEN, NOTBETWEEN -->
    <mat-form-field
      style="width: 100%"
      appearance="fill"
      *ngIf="
        fieldConstrain.constrain.type == numberConstrainType.BETWEEN ||
        fieldConstrain.constrain.type == numberConstrainType.NOTBETWEEN
      "
    >
      <mat-date-range-input [formGroup]="dateRange" [rangePicker]="rangePicker">
        <input
          matStartDate
          formControlName="start"
          placeholder="{{ numberConstrainType.BETWEEN ? 'After' : 'Bafore' }}"
          (dateChange)="changeConstrainState($event, 'date-value1')"
        />
        <input
          matEndDate
          formControlName="end"
          placeholder="{{ numberConstrainType.BETWEEN ? 'Before' : 'After' }}"
          (dateChange)="changeConstrainState($event, 'date-value2')"
        />
      </mat-date-range-input>
      <mat-datepicker-toggle
        matSuffix
        [for]="rangePicker"
      ></mat-datepicker-toggle>
      <mat-date-range-picker #rangePicker></mat-date-range-picker>
    </mat-form-field>
  </div>
</ng-template>

<ng-template #stringConstrainSelector>
  <mat-accordion>
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon *ngIf="swEnable.checked" color="accent">
            radio_button_checked
          </mat-icon>
          <mat-icon *ngIf="!swEnable.checked" style="color: gray"
            >radio_button_checked</mat-icon
          >
          <span class="flex-center">&nbsp;Starts with</span>
        </mat-panel-title>
        <mat-panel-description>
          <span class="flex-center">{{ swInput.value }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <form [formGroup]="stringFormGroup" (change)="updateStringConstrain()">
        <mat-form-field appearance="fill">
          <mat-label>Value</mat-label>
          <input
            matInput
            autocomplete="off"
            #swInput
            formControlName="startWith"
          />
        </mat-form-field>
        <mat-slide-toggle
          (change)="updateStringConstrain()"
          #swEnable
          style="margin-left: 1rem"
          formControlName="startWithToogle"
        ></mat-slide-toggle>
      </form>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon *ngIf="siEnable.checked" color="accent"
            >radio_button_checked</mat-icon
          >
          <mat-icon *ngIf="!siEnable.checked" style="color: gray"
            >radio_button_checked</mat-icon
          >
          <span class="flex-center">&nbsp;Includes</span>
        </mat-panel-title>
        <mat-panel-description>
          <span class="flex-center">{{ siInput.value }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <form [formGroup]="stringFormGroup" (change)="updateStringConstrain()">
        <mat-form-field appearance="fill">
          <mat-label>Value</mat-label>
          <input
            matInput
            autocomplete="off"
            #siInput
            formControlName="includes"
          />
        </mat-form-field>
        <mat-slide-toggle
          (change)="updateStringConstrain()"
          #siEnable
          style="margin-left: 1rem"
          formControlName="includesToogle"
        ></mat-slide-toggle>
      </form>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle style="margin-bottom: 1rem">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon *ngIf="ewEnable.checked" color="accent"
            >radio_button_checked</mat-icon
          >
          <mat-icon *ngIf="!ewEnable.checked" style="color: gray"
            >radio_button_checked</mat-icon
          >
          <span class="flex-center">&nbsp;Ends with</span>
        </mat-panel-title>
        <mat-panel-description>
          <span class="flex-center">{{ ewInput.value }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <form [formGroup]="stringFormGroup" (change)="updateStringConstrain()">
        <mat-form-field appearance="fill">
          <mat-label>Value</mat-label>
          <input
            matInput
            autocomplete="off"
            #ewInput
            formControlName="endsWith"
          />
        </mat-form-field>
        <mat-slide-toggle
          (change)="updateStringConstrain()"
          #ewEnable
          style="margin-left: 1rem"
          formControlName="endsWithToogle"
        ></mat-slide-toggle>
      </form>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
